import { monthLabel, monthOf } from '@deizi/shared';
import { useState } from 'react';
import { useReportMonths } from '../lib/reports-api';

export const PACK_ITEMS = [
  {
    key: 'resultado',
    label: 'Resultado do mês (PDF)',
    sub: 'receita, custos, margem de contribuição e lucro',
    on: true,
  },
  {
    key: 'receitas',
    label: 'Relatório mensal de receitas brutas (PDF)',
    sub: 'modelo do MEI, separado por venda com e sem nota',
    on: true,
  },
  {
    key: 'despesas',
    label: 'Despesas com recibos',
    sub: 'planilha + fotos e PDFs anexados',
    on: true,
  },
  {
    key: 'vendas',
    label: 'Vendas por canal (CSV) e notas',
    sub: 'pedidos, comissões e tarifas de cada canal, com os XML e PDF das NF',
    on: true,
  },
  {
    key: 'equipamentos',
    label: 'Equipamentos e parcelas',
    sub: 'valor, parcelas pagas e depreciação',
    on: false,
  },
] as const;

/** "Pacote do contador": month + checklist, downloaded as a .zip (no e-mail yet). */
export function AccountingPackForm({ initialMonth }: { initialMonth?: string }) {
  const months = useReportMonths();
  const current = monthOf();
  const [month, setMonth] = useState(initialMonth ?? current);
  const [items, setItems] = useState<string[]>(PACK_ITEMS.filter((i) => i.on).map((i) => i.key));
  const options = months.data?.months ?? [current];
  const href = `/api/v1/accounting-pack.zip?month=${month}&items=${items.join(',')}`;
  return (
    <div className="col" style={{ gap: 10 }}>
      <div className="field">
        <label htmlFor="pack-month">Mês</label>
        <select
          id="pack-month"
          className="input"
          value={month}
          onChange={(e) => setMonth(e.target.value)}
        >
          {options.map((m) => (
            <option key={m} value={m}>
              {monthLabel(m)}
              {m === current ? ' (parcial, até hoje)' : ''}
            </option>
          ))}
        </select>
      </div>
      <span className="lbl">O que vai no pacote</span>
      <div className="col" style={{ gap: 0 }}>
        {PACK_ITEMS.map((i) => {
          const on = items.includes(i.key);
          return (
            <button
              key={i.key}
              type="button"
              className="check"
              role="checkbox"
              aria-checked={on}
              onClick={() => setItems(on ? items.filter((k) => k !== i.key) : [...items, i.key])}
            >
              <span className={on ? 'box on' : 'box'} aria-hidden="true">
                {on ? '✓' : ''}
              </span>
              <span className="grow" style={{ textAlign: 'left' }}>
                <span style={{ display: 'block', fontWeight: 500 }}>{i.label}</span>
                <span className="xs muted">{i.sub}</span>
              </span>
            </button>
          );
        })}
      </div>
      {items.length === 0 ? <span className="help err">Escolha pelo menos um item.</span> : null}
      <p className="xs muted">Arquivo: contador-{month}.zip</p>
      {items.length ? (
        <a className="btn p" href={href} download>
          Gerar e baixar
        </a>
      ) : (
        <button type="button" className="btn p" disabled>
          Gerar e baixar
        </button>
      )}
    </div>
  );
}
